import React, { useState } from 'react';
import { KeyRound } from 'lucide-react';
import { istPinForm } from '../../../services/sifa/kundenportalLogic';
import { PIN_LAENGE } from '../../../services/sifa/kundenportalTypes';
import { EINGABE, EINGABE_FEHLER, FEHLERKASTEN, HINWEISKASTEN, KNOPF_PRIMAER } from '../public/teilnahmeSeiteStil';

/** PIN-Eingabe: sechs Ziffern, Zifferntastatur am Handy, Meldung aus der RPC (Versuche, Sperre). */
export const PinAnsicht: React.FC<{
  busy: boolean;
  meldung: string | null;
  onAnmelden: (pin: string) => void;
}> = ({ busy, meldung, onAnmelden }) => {
  const [pin, setPin] = useState('');
  const [formFehler, setFormFehler] = useState<string | null>(null);

  const absenden = (e: React.FormEvent) => {
    e.preventDefault();
    if (!istPinForm(pin)) {
      setFormFehler(`Bitte die ${PIN_LAENGE}-stellige PIN eingeben.`);
      return;
    }
    setFormFehler(null);
    onAnmelden(pin.trim());
  };

  return (
    <form onSubmit={absenden} className="space-y-4 max-w-md">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl bg-blue-50 border border-blue-100 flex items-center justify-center shrink-0">
          <KeyRound className="w-5 h-5 text-blue-600" />
        </div>
        <div>
          <h2 className="text-lg font-bold text-slate-900">Zugang mit PIN</h2>
          <p className="text-sm text-slate-500">Die PIN haben Sie von Ihrer Fachkraft für Arbeitssicherheit erhalten.</p>
        </div>
      </div>

      <label className="block">
        <span className="text-sm font-semibold text-slate-700">PIN ({PIN_LAENGE} Ziffern)</span>
        <input
          type="password"
          inputMode="numeric"
          autoComplete="one-time-code"
          pattern="[0-9]*"
          maxLength={PIN_LAENGE}
          value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, PIN_LAENGE))}
          disabled={busy}
          autoFocus
          className={`${EINGABE} mt-1 tracking-[0.4em] text-center text-xl ${formFehler ? EINGABE_FEHLER : ''}`}
          aria-invalid={!!formFehler}
        />
      </label>

      {formFehler && <div className={FEHLERKASTEN}>{formFehler}</div>}
      {meldung && !formFehler && <div className={HINWEISKASTEN} role="status">{meldung}</div>}

      <button type="submit" disabled={busy || pin.length < PIN_LAENGE} className={KNOPF_PRIMAER}>
        {busy ? 'Einen Moment…' : 'Anmelden'}
      </button>

      <p className="text-xs text-slate-500">
        Nach zehn falschen Eingaben wird der Zugang für eine Stunde gesperrt. Die PIN wird nur in diesem Browser-Tab gemerkt.
      </p>
    </form>
  );
};
